import React, { Component } from 'react';
import { Switch } from 'antd';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { actions } from "store";
import { arrayIsEqual, tableColumn } from "utils";
import { ActionButton, Photo, TableList } from "components/common";


class ArticleList extends Component {
  state = {
    updateItemId: null,
    columnList: ['title', 'image', 'slug', 'is_published', 'actions'],
    columnByName: {
      title: tableColumn('Тайтл', 'title', {
        sorter: true,
      }),
      image: tableColumn('Картинка', 'image', {
        render: (val, item) => <Photo url={val && val.url} width={80} height={60}/>,
        width: 112,
      }),
      slug: tableColumn('Путь', 'slug', {
        sorter: true,
      }),
      is_published: tableColumn('Опубликовано', 'is_published', {
        width: 120,
        sorter: true,
        render: (val, item) =>
          <div>
            <Switch
              style={{ marginTop: '5px', minWidth: '62px' }}
              checkedChildren="да" unCheckedChildren="нет"
              checked={item.is_published}
              loading={this.props.article.updateStatus.isLoading && this.state.updateItemId === item.id}
              onClick={() => this.articleOnOff(item)}
            />
          </div>,
      }),
      actions: tableColumn('', 'actions', {
        align: 'right',
        render: (val, item) => (
          <ActionButton
            actions={[{
              title: 'Редактировать', key: 'edit', icon: 'edit', action: () => this.showEditForm(item),
            }, {
              title: 'Удалить', key: 'delete', icon: 'delete', action: () => this.delete(item),
              confirm: {
                title: 'Уверены, что хотите удалить?',
                okText: 'Удалить',
                cancelText: 'Отмена'
              }
            }]}
          />
        ),
      }),
    },
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { columnList } = nextProps;
    if (columnList && !arrayIsEqual(prevState.columnList, columnList)) {
      return {
        columnList: columnList,
      }
    }
    return null;
  }

  load = ({ query, activeFilter }) => {
    this.props.actions.articleListLoad({ query, activeFilter });
  };

  showEditForm = (item) => {
    this.props.actions.articleShowEditForm({ show: true, object: item })
  };

  delete = (item) => {
    this.props.actions.articleDelete({ id: item.id })
  };

  articleOnOff = (item) => {
    const data = { id: item.id, is_published: !item.is_published, preventLoadDetail: true };
    this.setState({
      updateItemId: item.id,
    });
    this.props.actions.articleUpdate(data);
  };

  render() {
    const { history, defaultFilter, activeFilter, topActions, article } = this.props;
    const { columnList, columnByName } = this.state;

    return (
      <TableList
        history={history}
        data={article}
        defaultFilter={defaultFilter}
        activeFilter={activeFilter}
        topActions={topActions}
        columnList={columnList}
        columnByName={columnByName}
        onLoadData={this.load}
        showSearch={true}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    article: state.article,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.article), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleList);